import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiAward, FiDollarSign, FiHeadphones, FiZap } from 'react-icons/fi';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const features = [
    {
      title: "High Quality Service",
      description: "We provide top-notch services that ensure customer satisfaction and long-lasting relationships.",
      Icon: FiAward,
    },
    {
      title: "Affordable Prices",
      description: "Our prices are competitive and designed to provide maximum value for your money.",
      Icon: FiDollarSign,
    },
    {
      title: "Friendly Support",
      description: "Our team is here to guide you, answer your questions, and help you choose the best style.",
      Icon: FiHeadphones,
    },
    {
      title: "Fast, Professional Styling",
      description: "We work efficiently while keeping quality high, so you leave looking and feeling your best.",
      Icon: FiZap,
    },
  ];

  return (
    <Container className="whychoose-bg" fluid >
      <div className="whychoose-header text-center">
        <span className="whychoose-label">Why Us</span>
        <h2>Why Choose Us</h2>
      </div>
      <Row className="g-3">
        {features.map((feature) => {
          const { Icon } = feature;
          return (
          <Col key={feature.title} sm={12} md={6} lg={3}>
            <div className="whychoose-card h-100">
              <div className="whychoose-icon-wrap">
                <Icon className="whychoose-icon" />
              </div>
              <div className="whychoose-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </div>
          </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default WhyChooseUs;
